import { useEffect, useState } from 'react';

export const useUserWatcher = () => {
  const [isUserScrolling, setIsUserScrolling] = useState(false);
  const [heightPosition, setHeightPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setIsUserScrolling(true);
      const position = window.scrollY;
      setHeightPosition(position);
    };
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return { isUserScrolling, heightPosition };
};
